import { createFileRoute } from '@tanstack/react-router';

import { LanguageStep } from '@/features/onboarding/components/steps/personal/languageStep';

export const Route = createFileRoute('/_protected/onboarding/_steps/languages')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  return <LanguageStep />;
}
